import angular from 'angular'

const schema = {
  cobro_impuesto_estatal: 'boolean',
  comision_porcentaje: 'number',
  comision_porcentaje_sa: 'number',
  comision_porcentaje_op: 'number',
  iva_porcentaje: 'number',
  impuestos: {
    porcentaje: 'number',
    tipoId: 'number',
  }
}

class NominasCatalogosService {
  constructor ($http) {
    this.$http = $http
  }

  esquemas (idProyecto) {
    return this.$http.get('/api/nominas/catalogos/esquemas', {
      params: {id_proyecto: idProyecto},
      schema,
    })
  }

  tiposNomina () {
    return this.$http.get('/api/catalogo/tipos_nomina', {
      schema: {id: 'number'},
    })
  }

  regimenesFiscales () {
    return this.$http.get('/app/catalogos/regimenes_fiscales', {
      schema: {id: 'number'},
    })
  }

  prorrateo (idProyecto) {
    return this.$http.get('/api/nominas/prorrateo', {
      params: {id_proyecto: idProyecto},
      schema: {id: 'number'},
    })
  }

  monedas () {
    return this.$http.get('/app/catalogos/monedas')
      .then(function (response) {
        response.data = response.data.map(function (item) {
          return {id: Number(item.ID_Moneda), descripcion: item.Moneda}
        })

        return response
      })
  }
}

angular.module('nominas.catalogos')
  .service('NominasCatalogos', NominasCatalogosService)



// WEBPACK FOOTER //
// ./src/nominas/catalogos/services/NominasCatalogos.js